import CloudBackupSettings from './Cloud';

export default CloudBackupSettings;
